module.exports = __webpack_public_path__ + "img/bo.2d373f6e.svg";